{
  "avatar": {
    "upload": "Télécharger l'avatar",
    "change": "Changer l'avatar",
    "delete": "Supprimer l'avatar",
    "cropImage": "Recadrer l'image",
    "zoom": "Zoom",
    "uploadSuccess": "Avatar téléchargé avec succès",
    "uploadError": "Échec du téléchargement de l'avatar",
    "deleteSuccess": "Avatar supprimé avec succès",
    "deleteError": "Échec de la suppression de l'avatar",
    "invalidFile": "Type ou taille de fichier invalide",
    "fileReadError": "Échec de la lecture du fichier"
  },
  "logo": {
    "prepareError": "Échec de la préparation du téléchargement du logo",
    "uploadSuccess": "Logo téléchargé avec succès",
    "uploadError": "Échec du téléchargement du logo",
    "deleteSuccess": "Logo supprimé avec succès",
    "deleteError": "Échec de la suppression du logo"
  }
}
